import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "fs-4" }
const _hoisted_3 = { class: "fs-6" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["col-12", [_ctx.img? 'col-md-6' : '']])
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.subTitle), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.des, (des) => {
          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(des), 1))
        }), 256))
      ])
    ], 2),
    (_ctx.img)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "img-fluid",
            src: require(`@/assets/img/${_ctx.img}`)
          }, null, 8, _hoisted_5),
          _createElementVNode("p", null, _toDisplayString(_ctx.imgDes), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}